import * as svg from "../../../assets/calendar-multiple-icon.svg";

import {iconBuilder} from "./iconBuilder";

export const CalendarMultipleIcon = iconBuilder(svg, "CalendarMultipleIcon", "0 0 16 16");
